/**
 * Parse business phones field which can be a string, array, or JSON string
 * Returns the first phone number or empty string
 */
export function parseBusinessPhone(businessPhones: string | string[] | undefined): string {
  if (!businessPhones) return '';
  
  // Already an array
  if (Array.isArray(businessPhones)) {
    return businessPhones[0] || '';
  }
  
  // String - might be JSON
  if (typeof businessPhones === 'string') {
    try {
      const parsed = JSON.parse(businessPhones);
      return Array.isArray(parsed) ? parsed[0] || '' : businessPhones;
    } catch {
      // Not valid JSON, return as-is
      return businessPhones;
    }
  }
  
  return '';
}
